import { axios } from '../main'

export default class EmailReportingConfigurationsResource {
    static async get(websiteId) {
        return await axios.get(process.env.VUE_APP_REST_API + `email-reporting-configurations/${websiteId}`)
    }

    static async apply(websiteId, name, value) {
        return await axios.post(process.env.VUE_APP_REST_API + `email-reporting-configurations`, {
            website_id: websiteId,
            name,
            value
        })
    }
}
